__turbopack_context__.v({
  "ant-dropdown-menu": "A9LdCG_ant-dropdown-menu",
  "avatar": "A9LdCG_avatar",
  "avatarMobile": "A9LdCG_avatarMobile",
  "badgeNew": "A9LdCG_badgeNew",
  "btn": "A9LdCG_btn",
  "btnPrimary": "A9LdCG_btnPrimary",
  "button": "A9LdCG_button",
  "container": "A9LdCG_container",
  "fullWidthDropdown": "A9LdCG_fullWidthDropdown",
  "headerIcon": "A9LdCG_headerIcon",
  "headerWrapper": "A9LdCG_headerWrapper",
  "logo": "A9LdCG_logo",
  "menuName": "A9LdCG_menuName",
  "menus": "A9LdCG_menus",
  "newMenu": "A9LdCG_newMenu",
  "pModal": "A9LdCG_pModal",
  "page-body-wrap": "A9LdCG_page-body-wrap",
  "paragraph-content": "A9LdCG_paragraph-content",
  "positionTop": "A9LdCG_positionTop",
  "pulse": "A9LdCG_pulse",
  "search": "A9LdCG_search",
  "store": "A9LdCG_store",
  "titleModal": "A9LdCG_titleModal",
  "wrap-container": "A9LdCG_wrap-container",
  "wrap-content": "A9LdCG_wrap-content",
});
